import { render, staticRenderFns } from "./AminComment.vue?vue&type=template&id=aa760a96&scoped=true&"
import script from "./AminComment.vue?vue&type=script&lang=js&"
export * from "./AminComment.vue?vue&type=script&lang=js&"
import style0 from "./AminComment.vue?vue&type=style&index=0&id=aa760a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa760a96",
  null
  
)

export default component.exports